import React, { useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { OpenInNew } from '@mui/icons-material';

// Types
import { TCustomGFIDKPProps } from '@/@types/views/map';

// Custom
import MapCardActionButton from '@/ui/MapCard/MapCardActionButton';
import DataController from '@/lib/DataController';
import UserContext from '@/context/UserContext/UserContext';
import Permissions from '@/lib/permissions';
import DCTable from '@/ui/Table/DCTable';
import GMKorisnici from '@/models/groblja/grobno_mjesto_korisnici';
import GeneralGrobljaDialog from '@/views/Groblja/GeneralGrobljaDialog';

const GMKorisniciButton = (props: TCustomGFIDKPProps) => {
  const identifier = 'korisnici';

  const userContext = useContext(UserContext);

  const canEdit = userContext?.hasAnyPermission([Permissions.GrobljaManageOsnovniRegistri]);

  const { t } = useTranslation();

  const { record, onToggle } = props;

  const recordId = useMemo(
    () =>
      record ? (record.id ? record.id : record.fid ? record.fid : null) : null,
    [record]
  );

  const grobljeId = useMemo(
    () => record?.groblje_id ?? null,
    [record]
  );

  const dcKorisnici = useMemo(
    () =>
      new DataController(
        GMKorisnici,
        `groblja/grobna-mjesta/${recordId}/osobe`
      ),
    [recordId]
  );

  const korisniciTable = (
    <DCTable
      allowExport
      title="groblja:titles.korisnici_grobnog_mjesta"
      size="small"
      tableName="korisnici"
      viewName="grobno_mjesto_korisnici"
      dc={dcKorisnici}
      allowSelection="one"
      allowAdd={canEdit}
      allowEdit={canEdit}
      allowDelete={canEdit}
      allowRowAction={() => false}
      onRowAction={() => {}}
      disableControls={false}
      allowColumnPicker={true}
      dialogComponent={GeneralGrobljaDialog}
      foreignKeyValue={{ grobno_mjesto_id: recordId, groblje_id: grobljeId }}
      // TODO add history
    />
  );

  const handleToggleKorisnici = () => {
    onToggle(korisniciTable, identifier);
  };

  return (
    <MapCardActionButton
      startIcon={<AssignmentIndIcon />}
      onClick={handleToggleKorisnici}
      endIcon={<OpenInNew />}
    >
      {t('titles.korisnici')}
    </MapCardActionButton>
  );
};

export default GMKorisniciButton;
